import React from 'react';
import Button from 'components/Button';
import Confetti from 'components/Confetti';
import Container from 'components/Container';
import EventTracking from 'lib/EventTracking';
import Image from 'components/Image';
import LinkConstants from 'constants/LinkConstants';
import Row from 'components/Row';
import TitleHeader from 'components/TitleHeader';

import CompletedImage from 'assets/images/coaching/completed_illustration.svg';

export default class CoachingSuccessPage extends React.Component {
  componentDidMount() {
    EventTracking.trackKey('coaching.confirmation.view');
  }

  render() {
    return (
      <React.Fragment>
        <Confetti />
        <div className="CoachingSuccessPage-content">
          <Container size="large">
            <Row>
              <Image src={CompletedImage} width="100%" />
            </Row>
            <TitleHeader
              title="Thanks for signing up!"
              subtext="You and your child will receive an email with instructions for scheduling your first
                session."
              action={
                <Button eventKey="coaching.confirmation.exit.click" href={LinkConstants.COACHING}>
                  Close
                </Button>
              }
            />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
